export default "__VITE_ASSET__Bjb1E_9Y__"